import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenancePageGuard implements CanActivate {
    constructor(private router: Router) {}
    
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        // Check if the maintenance flag is set
        if (environment?.isMaintenance) {
        // Navigate to the maintenance page
        return this.router.navigate(['/maintenance']);
        }
    
        // Allow navigation if the maintenance flag is not set
        return true;
    }
}